export const supplant = string => (params = {}) => {
  return string.replace(/{{([^{}]*)}}/g, (entry, paramName) => {
    const value = params[paramName];
    return typeof value === 'string' || typeof value === 'number' ? value : entry;
  });
};
